<!-- Full-screen image viewer. Backdrop click closes; child controls stop
     propagation. Pinch/pan on touch + wheel/buttons on desktop via appPinchZoom. -->
@if (isOpen) {
  <div class="v2-lightbox" (click)="close()">
    @if (currentSrc(); as src) {
      <a class="v2-lightbox__download"
         [href]="src"
         [download]="currentDownloadName()"
         target="_blank" rel="noopener noreferrer"
         (click)="$event.stopPropagation()"
         aria-label="Prenesi" i18n-aria-label>
        <i class="fas fa-download"></i>
      </a>
    }
    <button type="button" class="v2-lightbox__close"
            (click)="$event.stopPropagation(); close()"
            aria-label="Zapri" i18n-aria-label>
      <i class="fas fa-times"></i>
    </button>

    <!-- Zoom controls (desktop). Touch users pinch-to-zoom directly on the image. -->
    <div class="v2-lightbox__zoom" (click)="$event.stopPropagation()">
      <button type="button" class="v2-lightbox__zoom-btn"
              (click)="zoomOut()" aria-label="Pomanjšaj" i18n-aria-label>
        <i class="fas fa-minus"></i>
      </button>
      <button type="button" class="v2-lightbox__zoom-btn"
              (click)="zoomIn()" aria-label="Povečaj" i18n-aria-label>
        <i class="fas fa-plus"></i>
      </button>
    </div>

    @if (hasPrev()) {
      <button type="button" class="v2-lightbox__nav v2-lightbox__nav--prev"
              (click)="$event.stopPropagation(); prev()"
              aria-label="Prejšnja" i18n-aria-label>
        <i class="fas fa-chevron-left"></i>
      </button>
    }
    @if (hasNext()) {
      <button type="button" class="v2-lightbox__nav v2-lightbox__nav--next"
              (click)="$event.stopPropagation(); next()"
              aria-label="Naslednja" i18n-aria-label>
        <i class="fas fa-chevron-right"></i>
      </button>
    }
    @if (currentSrc(); as src) {
      <img class="v2-lightbox__img"
           appPinchZoom [maxZoom]="5"
           (swipeLeft)="next()" (swipeRight)="prev()"
           [src]="src"
           [alt]="altText()"
           (click)="$event.stopPropagation()" />
    }
    <div class="v2-lightbox__counter">
      @if (isPremiumSlot()) {
        <span class="v2-lightbox__premium-tag" i18n>★ CARPEAK</span>
      } @else {
        {{ index + 1 }} / {{ images.length }}
      }
    </div>
    @if (images.length > 1) {
      <div class="v2-lightbox__thumbs" (click)="$event.stopPropagation()">
        @for (img of images; track img.src; let i = $index) {
          <button type="button"
                  #thumbnail
                  class="v2-lightbox__thumb"
                  [class.is-active]="i === index"
                  (click)="goTo(i)"
                  [attr.aria-label]="alt + ' ' + (i + 1)">
            <img [src]="img.src" [alt]="alt + ' ' + (i + 1)" />
          </button>
        }
      </div>
    }
  </div>
}
